import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import BreatheEasyWorkHard from "./sections/BreatheEasyWorkHard";
import TrustLine from "./sections/TrustLine";
import OnzeReparatiediensten from "./sections/OnzeReparatiediensten";
import ServiceProcess from "./sections/ServiceProcess";
import LocationMap from "./sections/LocationMap";
import CustomerReviews from "./sections/CustomerReviews";
import ReadyToStart from "./sections/ReadyToStart";
import PremiumInspections from "./sections/PremiumInspections";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <BreatheEasyWorkHard />
      <TrustLine />
      <OnzeReparatiediensten />
  <ServiceProcess />
      <PremiumInspections />

      <LocationMap />
      <CustomerReviews />
      <ReadyToStart />
      <Footer />
    </div>;
}